export default () => ({
    filters: {

        // Где ищем
        type: [],

        // Строка запроса
        query: '',
    },
    default_filters: {

        // Где ищем
        type: ['all'],

        // Строка запроса
        query: '',
    },
    _abortController: null,
    state: {

        // Строка запроса (для поля ввода)
        query: '',

        // Флаг изменения активной записи истории
        from_popstate: false,

        // Контейнер для контента с пагинацией
        paged_content_element: null,

        // Элемент с шаблоном скелетона
        skeleton_template_element: null,

        // Значение сдвига полосы прокрутки
        loading_scroll_top: 0,

        // Язык
        lang: 'ru',

        // Номер текущей страницы
        page: 1,

        // Флаг загрузки
        is_loading: false,

        // Флаг необходимости повторной загрузки (поменялись фильтры)
        is_need_to_load: false,

        // Флаг наличия следующей страницы
        has_next_page: false,

        // URL следующей страницы для ссылки (могут открыть в новой вкладке)
        next_page_url: '',

        // Базовый URL запроса, добавляется перед маршрутом
        base_url: '',

        // Маршрут запроса
        route: '',

        // Развернуть фильтры на мобильном экране?
        show_filters: false,
    },

    init() {
        this.initState();
        this.initFilters();

        this.handlePopState();

        if (this.state.query.length) {
            Alpine.store('global').addSearchHistory(this.state.query);
        }

        this.updateSidebarSuggestions();
    },

    initState() {

        // noinspection JSUnresolvedReference
        this.state.paged_content_element = this.$root.querySelector('#paged_content');

        if (!this.state.paged_content_element) {
            throw new Error('Не удалось найти контейнер для контента с пагинацией');
        }

        // noinspection JSUnresolvedReference
        this.state.skeleton_template_element = this.$root.querySelector('#content_skeleton');

        // noinspection JSUnresolvedReference
        this.state.lang = this.$root.getAttribute('data-lang');

        // noinspection JSUnresolvedReference
        this.state.page = parseInt(this.$root.getAttribute('data-page'));

        // noinspection JSUnresolvedReference
        this.state.has_next_page = !!this.$root.getAttribute('data-has-next-page');

        // noinspection JSUnresolvedReference
        this.state.next_page_url = this.$root.getAttribute('data-next-page-url');

        // noinspection JSUnresolvedReference
        this.state.base_url = this.$root.getAttribute('data-base-url').replace(/\/$/, '');

        // noinspection JSUnresolvedReference
        this.state.route = this.$root.getAttribute('data-route').replace(/\/$/, '');

        // noinspection JSUnresolvedReference
        this.state.query = this.$root.getAttribute('data-search-query');
    },

    initFilters() {
        const debouncedLoadPage = Alpine.debounce(this.loadPage.bind(this), 500);

        const urlParams = new URLSearchParams(window.location.search);

        // noinspection JSUnresolvedReference
        this.filters.query = urlParams.get('s') || this.$root.getAttribute('data-search-query');

        Alpine.nextTick().then(() => {
            Alpine.nextTick().then(() => {
                // noinspection JSUnresolvedReference
                this.$watch('filters', (value, oldValue) => {

                    console.debug('Значение фильтров обновилось (value, oldValue):', value, oldValue);

                    this.state.is_need_to_load = true;

                    // history

                    let searchParamsData = this.getSearchParamsData()

                    const historySearchParams = new URLSearchParams(searchParamsData).toString().replace(/%2C/g, ',');

                    if (!this.state.from_popstate) {

                        const data = JSON.parse(JSON.stringify(this.filters));

                        const url = this.state.base_url + this.state.route + '?' + historySearchParams;

                        history.pushState(data, window.title, url);
                    }

                    // load debounced

                    debouncedLoadPage(1, this.state.from_popstate, false);
                });
            });
        });
    },

    normalizeQuery(query) {
        // Угловые скобки рушат WAF-паттерн (403 на '>, "<, ">, '< и т.п.) и в поиске
        // по театру не значат ничего. Вырезаем именно их; кавычки/апострофы внутри слов
        // оставляем — они есть в реальных именах (О'Нил, d'Artagnan).
        const cleaned = (query || '').replace(/[<>]/g, ' ').replace(/\s+/g, ' ').trim();

        // Запрос без единой буквы/цифры (осталась только пунктуация: ', ", …) — это не
        // поиск. Считаем его пустым, иначе поле залипает на одиночной «'», а фолбэк на URL
        // ниже втягивает ту же «'» из адресной строки обратно в запрос.
        if (!/[\p{L}\p{N}]/u.test(cleaned)) {
            return '';
        }

        return cleaned;
    },

    getSearchParamsData() {

        let data = {}

        // Строка запроса (нормализованная). s присутствует всегда, даже пустой —
        // чтобы сервер видел is_search() и сам отрендерил корректную выдачу и крошки
        // (в т.ч. «пустой поиск» при сбросе запроса). filters.query — единственный
        // источник истины; фолбэк на ?s= из URL убран, он втягивал устаревший запрос.
        data.s = this.normalizeQuery(this.filters.query);

        // Где ищем
        const type = this.filters.type.join(',');

        if (type.length) {
            data.type = type;
        }

        return data;
    },

    handlePopState() {

        // Обработчик события изменения URL
        window.addEventListener('popstate', (event) => {

            this.state.from_popstate = true;

            this.state.page = 1;

            for (let key in this.filters) {
                if (this.default_filters.hasOwnProperty(key)) {
                    this.filters[key] = this.default_filters[key];
                }
            }

            if (event.state) {
                for (let key in this.filters) {
                    if (event.state.hasOwnProperty(key)) {
                        this.filters[key] = event.state[key];
                    }
                }
            }
        });
    },

    loadPage(page, from_popstate = false, focus = true) {
        console.debug('Load page ' + page, from_popstate);

        // Сохранить актуальный поисковый запрос
        this.state.query = this.filters.query;

        // Сброс значения popstate
        this.state.from_popstate = false;

        // Сброс флага необходимости загрузки
        this.state.is_need_to_load = false;

        // Параметры запроса (с нормализацией: вырезаны угловые скобки и т.п.).
        // Пустой/мусорный запрос тоже уходит на сервер (s=''): сервер отрендерит
        // пустую форму без результатов и корректные крошки — единым источником истины,
        // без редиректа на главную и без клиентского дублирования разметки.
        const searchParamsData = this.getSearchParamsData();

        // Сохранить непустой поисковый запрос в историю запросов
        if (searchParamsData.s) {
            Alpine.store('global').addSearchHistory(searchParamsData.s);
        }

        if (this.state.is_loading) {
            if (page > 1) {
                this.state.is_need_to_load = true;
                console.debug('Загрузка страницы уже выполняется');
                return;
            }
            this._abortController?.abort();
        }

        if (page > this.state.page && !this.state.has_next_page) {
            console.debug('Нет такой страницы');
            return;
        }

        this.state.is_loading = true;
        this.state.page       = page;

        let routePaged = this.state.route;

        if (this.state.page > 1) {
            routePaged += '/page/' + this.state.page;
        } else {
            this.clearPagedContainer('Загрузка с новой страницы');
        }

        if (focus) {
            this.focusLastItem();
        }

        // Сохранить положение прокрутки
        this.state.loading_scroll_top = window.scrollY;

        // Заглушка
        this.appendSkeleton(5);

        // Восстановить положение прокрутки
        window.scrollTo(0, this.state.loading_scroll_top);

        searchParamsData.json = 1;

        const controller = new AbortController();
        this._abortController = controller;

        // noinspection JSCheckFunctionSignatures
        axios.get(routePaged, {

            baseURL: this.state.base_url,

            params: searchParamsData,

            signal: controller.signal,

            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },

        }).then(response => {

            this.state.page = response.data.page ?? 1;

            if (this.state.page === 1) {
                this.clearPagedContainer('Сброс пагинации');
            }

            this.state.paged_content_element.insertAdjacentHTML('beforeend', response.data.content ?? '');

            this.state.has_next_page = response.data.has_next_page ?? false;

            this.state.next_page_url = response.data.next_page_url ?? '';

            // Серверные хлебные крошки — единый источник истины, подменяем целиком
            this.updateBreadcrumbs(response.data.breadcrumbs);

        }).catch(error => {
            if (axios.isCancel(error)) return;
            console.error(error);

            // Запрос не удался (403 от WAF, сеть, таймаут): контент не вставлен.
            // Сбрасываем пагинацию, иначе «Показать ещё» (x-if="state.next_page_url")
            // остаётся от прошлой загрузки и висит над пустым #paged_content.
            this.state.has_next_page = false;
            this.state.next_page_url = '';

            // На первой странице — честное сообщение об ошибке. НЕ «ничего не найдено»:
            // 403/500/сеть — это сбой запроса, его нельзя выдавать за пустой результат,
            // иначе настоящие инциденты маскируются. Нулевой результат рисует сервер сам.
            if (this.state.page <= 1) {
                this.renderRequestError();
            }
        }).finally(() => {
            if (this._abortController !== controller) return;

            this.removeSkeletons();

            this.state.is_loading = false;

            // noinspection JSUnresolvedReference
            this.state.query = searchParamsData.s || '';

            // Копируем подсказки для боковой панели
            this.updateSidebarSuggestions();

            // Если во время загрузки фильтры поменялись
            if (this.state.is_need_to_load) {
                this.state.is_need_to_load = false;
                this.loadPage(1, false, false);
            }

        });
    },

    renderRequestError() {
        if (!this.state.paged_content_element) {
            return;
        }

        // Небольшой клиентский блок — у сервера нет состояния «запрос не выполнен»,
        // поэтому дублирования разметки тут нет (в отличие от «ничего не найдено»).
        const t = this.state.lang === 'en'
            ? {
                title: 'Something went wrong',
                text: 'The request could not be completed. Please try again.',
            }
            : {
                title: 'Что-то пошло не так',
                text: 'Не удалось выполнить запрос. Попробуйте ещё раз.',
            };

        this.state.paged_content_element.innerHTML = `
            <h2 class="text-36 font-condensed font-normal leading-none uppercase">${t.title}</h2>
            <div class="editor-content text-18 mt-2">
                <p>${t.text}</p>
            </div>
        `;
    },

    updateBreadcrumbs(html) {
        // Подменяем #breadcrumbs серверной разметкой из ответа. Пустую строку
        // игнорируем, чтобы случайный пустой ответ не снёс крошки целиком.
        if (!html) {
            return;
        }

        const breadcrumbs = document.getElementById('breadcrumbs');
        if (breadcrumbs) {
            breadcrumbs.outerHTML = html;
        }
    },

    updateSidebarSuggestions(){
        const sidebar_suggestions = document.getElementById('search_sidebar_suggestions');
        const sidebar_suggestions_results = document.getElementById('search_sidebar_suggestions_results');

        // При ошибочном ответе (403 от WAF, сеть, таймаут) новый контент не вставился,
        // а #search_sidebar_suggestions_results живёт внутри #paged_content и уже стёрт
        // clearPagedContainer(). В этом случае оставляем прежние подсказки и выходим,
        // иначе чтение .innerHTML у null роняет весь рендер.
        if (!sidebar_suggestions || !sidebar_suggestions_results) {
            return;
        }

        sidebar_suggestions.innerHTML = sidebar_suggestions_results.innerHTML;
    },

    appendSkeleton(count) {
        console.debug('appendSkeleton');

        if (!this.state.skeleton_template_element) {
            console.warn('Шаблон заглушки не найден.');
            return;
        }

        for (let i = 0; i < count; i++) {
            this.state.paged_content_element.insertAdjacentHTML('beforeend', this.state.skeleton_template_element.innerHTML);
        }

        console.debug('appendSkeleton done');
    },

    removeSkeletons() {
        console.debug('removeSkeletons');

        const skeletonElements = this.state.paged_content_element.querySelectorAll('[data-skeleton]');
        skeletonElements.forEach(element => {
            element.remove();
            console.debug('skeleton removed');
        });

        console.debug('removeSkeletons done');
    },

    clearPagedContainer(reason) {
        console.debug('clearPagedContainer', reason);

        this.state.paged_content_element.innerHTML = '';
    },

    focusLastItem() {

        if (!this.state.skeleton_template_element) {
            console.warn('Шаблон заглушки не найден.');
            return;
        }

        const lastLink = this.state.paged_content_element.querySelector('.group\\/card:last-child a');

        if (!lastLink) {
            console.debug('last link not found - nothing to focus');
            return;
        }

        lastLink.focus({
            preventScroll: true
        });
    },

    toggleFilters() {
        this.state.show_filters = !this.state.show_filters;
    },

    hasActiveFilters() {
        return this.filters.type.some(type => type && type !== 'all');
    },

    doSearch() {
        console.debug('doSearch');

        const search_term = this.normalizeQuery(this.state.query);

        // Отражаем очищенный запрос в поле ввода
        this.state.query = search_term;

        this.state.show_filters = false;

        // Пустой/мусорный (только пунктуация) запрос: сбрасываем фильтр в пустоту —
        // loadPage покажет пустую форму без результатов, без запроса и без редиректа.
        this.filters.query = search_term;
    }
})
